import ModBadge from "../../components/common/ModBadge";
import Pagination from "../../components/sections/Pagination";
import { fmt, fmtDate } from "../../services/formatting";
import { convertMoney, getPlatformCurrency } from "../../services/currency";
import RegistroInlineEditRow from "./RegistroInlineEditRow";

const REGISTROS_COLUMNS = [
  "Plataforma",
  "Torneio",
  "Buy-in",
  "Modalidade",
  "Insc.",
  "Premiação",
  "Data",
  "",
];

function EmptyRegistrosState({ activeFilters }) {
  return (
    <div className="registros-table__empty">
      {activeFilters
        ? "Nenhum registro para os filtros selecionados."
        : "Nenhum registro ainda."}
      <br />
      {!activeFilters && (
        <span className="registros-table__empty-hint">
          Clique em "+ Registrar Participação" para começar.
        </span>
      )}
    </div>
  );
}

function RegistroRow({
  registro,
  index,
  getTournament,
  handleEditRegistro,
  setDeleteTarget,
  displayCurrency,
}) {
  const tournament = getTournament(registro.torneioId);
  const inscricoes = Number(registro.inscricoes || 1);
  const buyin = tournament ? Number(tournament.buyin) : 0;
  const plataforma = registro.plataforma || tournament?.plataforma || "";
  const investimento = buyin * inscricoes;
  const premiacao = Number(registro.premiacao || 0);
  const buyinCurrency = tournament?.buyinCurrency || getPlatformCurrency(plataforma);
  const prizeCurrency = registro.prizeCurrency || buyinCurrency;
  const displayInvestimento = convertMoney(
    investimento,
    buyinCurrency,
    displayCurrency
  );
  const displayPremiacao = convertMoney(
    premiacao,
    prizeCurrency,
    displayCurrency
  );
  const lucro = displayPremiacao - displayInvestimento;

  return (
    <div>
      {index > 0 && <hr className="divider" />}
      <div
        className={`tr registros-table__row motion-list-row motion-list-row--${Math.min(index, 8)}`}
      >
        <div className="registros-table__platform">
          <span className="platform-badge">
            {plataforma || "Sem plataforma"}
          </span>
        </div>
        <div className="registros-table__name">
          {tournament ? (
            tournament.nome
          ) : (
            <span className="registros-table__removed">removido</span>
          )}
        </div>
        <div className="registros-table__buyin">
          {fmt(buyin, buyinCurrency)}
          {inscricoes > 1 && (
            <span className="registros-table__buyin-count">
              ×{inscricoes}
            </span>
          )}
        </div>
        <div className="registros-table__modality">
          {tournament ? <ModBadge mod={tournament.modalidade || "Vanilla"} /> : "—"}
        </div>
        <div className="registros-table__entries">
          {inscricoes}
        </div>
        <div className="registros-table__prize-cell">
          {tournament?.modalidade === "SAT" ? (
            <div className="registros-table__prize">
              {Number(registro.tickets || 0)} ticket
              {Number(registro.tickets) !== 1 ? "s" : ""}
            </div>
          ) : (
            <>
              <div className="registros-table__prize">
                {fmt(premiacao, prizeCurrency)}
                {registro.isSatellite && (
                  <span className="registros-table__satellite-note">
                    (via SAT)
                  </span>
                )}
              </div>
              <div
                className={`registros-table__result ${
                  registro.isSatellite
                    ? "registros-table__result--muted"
                    : lucro >= 0
                    ? "registros-table__result--positive"
                    : "registros-table__result--negative"
                }`}
              >
                {registro.isSatellite ? "—" : (lucro >= 0 ? "+" : "") + fmt(lucro, displayCurrency)}
              </div>
            </>
          )}
        </div>
        <div className="registros-table__date">
          {fmtDate(registro.registradoEm)}
        </div>
        <div className="registros-table__actions">
          <button
            className="btn-icon btn-edit"
            title="Editar"
            onClick={() => handleEditRegistro(registro)}
          >
            ✎
          </button>
          <button
            className="btn-icon btn-del"
            title="Remover"
            onClick={() => setDeleteTarget({ type: "registro", id: registro.id })}
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}

export default function RegistrosTable({
  filtered,
  pageSlice,
  safePage,
  totalPages,
  setPage,
  activeFilters,
  registroForm,
  registroModal,
  tournaments,
  getTournament,
  handleEditRegistro,
  handleSaveRegistro,
  setDeleteTarget,
  displayCurrency,
}) {
  const cancelInlineEdit = () => {
    registroModal.close();
    registroForm.reset();
  };

  return (
    <>
      <div className="registros-table">
        <div className="registros-table__header">
          {REGISTROS_COLUMNS.map((header, index) => (
            <div key={index} className="registros-table__heading">
              {header}
            </div>
          ))}
        </div>

        {filtered.length === 0 && <EmptyRegistrosState activeFilters={activeFilters} />}

        {pageSlice.map((registro, index) =>
          registroModal.editingId === registro.id ? (
            <RegistroInlineEditRow
              key={registro.id}
              registro={registro}
              index={index}
              form={registroForm.values}
              errors={registroForm.errors}
              tournaments={tournaments}
              getTournament={getTournament}
              onChange={registroForm.setValues}
              onSave={handleSaveRegistro}
              onCancel={cancelInlineEdit}
              displayCurrency={displayCurrency}
            />
          ) : (
            <RegistroRow
              key={registro.id}
              registro={registro}
              index={index}
              getTournament={getTournament}
              handleEditRegistro={handleEditRegistro}
              setDeleteTarget={setDeleteTarget}
              displayCurrency={displayCurrency}
            />
          )
        )}
      </div>

      <Pagination page={safePage} totalPages={totalPages} onChange={setPage} />
    </>
  );
}
